module.exports = global["jQuery"] = require("-!/code/node_modules/expose-loader/index.js?$!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/dist/jquery.js-exposed
// module id = 141
// module chunks = 18